<template>
  <div>
    <cms-spotlight
      v-if="spotlightSetup"
      :theme="spotlightOptions"
      :content="homepage.spotlights[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import isEmpty from 'lodash/isEmpty';

defineOptions({ name: 'ViewSpotlights' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);
const isThemePreview = computed(() => mainStore.isThemePreview);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const spotlightOptions = computed(() => ({
  ...theme.value?.containers?.[props.containerIdx]?.components?.[props.componentIdx]?.options,
  translations: {
    ...translationStore.getComponentTranslation('spotlight'),
    ...translationStore.getGlobalTranslations,
  },
  globalThemeSettings: mainStore.getGlobalThemeSettings,
}));

const spotlightSetup = computed(() => {
  const spotlight = homepage.value?.spotlights?.[id.value];
  return !isEmpty(spotlight?.content) || !isEmpty(spotlight?.nested_content);
});
</script>
